const { GA_ID } = window.config;
/**
 * Sends a page_view event to Google Analytics via gtag.
 * @param {string} pagePath
 */
export const pageView = (pagePath) => {
  window.gtag('config', GA_ID, {
    page_path: pagePath,
  });
};

/**
 * Sends an event to Google Analytics via gtag.
 * View the [Developer Guide](https://developers.google.com/analytics/devguides/collection/app-web/events)
 * to review recommended events and their associated parameters.
 * @param {string} event
 * @param {!Object<string, *>} parameters
 */
export const event = (e, params) => {
  window.gtag('event', e, {
    send_to: GA_ID,
    ...params,
  });
};
